import request from "../axios-instance";
import { uploadIxdToStagingSlot } from "../ixd-upload/policy";
import type { IxdWorkbookCompareResponse } from "./types";

export type {
  TableRef,
  MatchedTableDiff,
  MergedTreeNode,
  IxdWorkbookCompareResponse,
} from "./types";

export const compareIxdWithWorkbook = async (
  workbookId: string,
  ixdFile: File,
): Promise<IxdWorkbookCompareResponse> => {
  const uploadId = await uploadIxdToStagingSlot(ixdFile);

  const compareForm = new FormData();
  compareForm.append("workbook_id", workbookId);
  compareForm.append("upload_id", uploadId);
  compareForm.append("filename", ixdFile.name);

  const response = await request.post(
    "/v1/ixd-workbook-compare/compare",
    compareForm,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};
